<template>
  <div class="home">
    <modal
      transition-name="fade-side"
      appear
      :comp="modalComponent"
      :handle-props="modalProps"
      :handle-events="modalEvents"
      :key="componentResetKey"
    />
  </div>
</template>

<script>
import Modal from "@/components/shared/Modal";
import Register from "@/components/auth/Register";
import Login from "@/components/auth/Login";
import ForgotPass from "@/components/auth/ForgotPassword";
import ResetPassword from "@/components/auth/ResetPassword";
import api from "@/api";
import { mapState, mapActions, mapMutations } from "vuex";
import moment from "moment";
const ageRestriction = moment().year() - 115;
export default {
  components: {
    Modal,
  },
  data() {
    return {
      modalComponent: null,
      onCall: false,
      loginEvents: {
        login: this.handleLogin,
      },
      registerEvents: {
        next: this.handleNext,
        register: this.handleRegister,
        terms: this.handleTerms,
        privacy: this.handlePrivacy,
      },
      activeField: 0,
      componentResetKey: 0,
      params: {},
      countries: [],
      isGettingCountries: false,
      registerFields: [
        [
          {
            text: "name",
            type: "text",
            validator: (value) => value.length > 0,
          },
          {
            text: "lastName",
            type: "text",
            validator: (value) => value.length > 0,
          },
          {
            text: "email",
            type: "text",
            validator: (value) => /^(\w+.?)+@(\w+.?)+.\w+$/.test(value.trim()),
          },
        ],
        [
          {
            text: "year",
            type: "select",
            options: (() =>
              new Array(100)
                .fill()
                .map((_, index) => ageRestriction + index)
                .reverse())(),
            // validator: (val) =>
            //   val <= ageRestriction + 100 && val >= ageRestriction && val,
          },
          {
            text: "gender",
            type: "select",
            options: (() => {
              const genders = this.$t("register.genderType");
              return Object.keys(genders).map((el) => {
                return {
                  code: el,
                  label: genders[el],
                };
              });
            })(),
            // validator: (val) =>
            //   Object.keys(this.$t("register.genderType")).indexOf(val) !== -1,
          },
          {
            text: "city",
            type: "text",
            validator: (val) => val.length > 2 && val.length < 100,
          },
        ],
        [
          {
            text: "password",
            type: "password",
            validator: (val) => val.length >= 8,
            visible: false,
          },
          {
            text: "confirmPassword",
            type: "password",
            validator: () => () => true,
            visible: false,
            matches: "password",
          },
          {
            text: "terms",
            type: "checkbox",
            validator: (val) => val === true,
          },
          {
            text: "privacy",
            type: "checkbox",
            validator: (val) => val === true,
          },
        ],
      ],
    };
  },
  computed: {
    ...mapState(['email','fairConfig']),
    routeParam() {
      return this.$route.params.action;
    },
    lastRegisterPage() {
      return this.activeField === this.filteredFields.length - 1;
    },
    modalProps() {
      if (this.routeParam === "login") {
        return {};
      }
      return {
        fields: new Array(...this.filteredFields[this.activeField]),
        page: this.lastRegisterPage,
      };
    },
    modalEvents() {
      return this.routeParam === "login"
        ? this.loginEvents
        : this.registerEvents;
    },
    filteredFields () {
      // filter step fields
      const regStepsWithFilteredFields = this.registerFields.map(stepFields => {
        return stepFields.filter(field => {
          if (field.text === 'year' && this.fairConfig.FC_REG_BIRTHDAY == 0) return false;
          if (field.text === 'gender' && this.fairConfig.FC_REG_GENDER == 0) return false;
          if (field.text === 'city' && this.fairConfig.FC_REG_CITY == 0) return false;
          if (field.text === 'country' && this.fairConfig.FC_REG_COUNTRY == 0) return false;

          return true;
        });
      });

      // filter steps
      return regStepsWithFilteredFields.filter(step => step.length > 0);
    },
  },
  watch: {
    routeParam: {
      immediate: true,
      handler(val) {
        if (val === "login") {
          this.modalComponent = Login;
        }
        if (val === "register") {
          this.modalComponent = Register;
          this.activeField = 0;
          this.params = [];
        }
        if (val === "forgotpassword") {
          this.modalComponent = ForgotPass;
        }
        if (val === "resetpassword") {
          this.modalComponent = ResetPassword;
        }
      },
    },
    // this handles the case if country field is not present initially but added later in real-time
    // call getCountries only if FC_REG_COUNTRY is 1 AND if api is not called before
    fairConfig: {
      deep: true,
      handler () {
        if (this.fairConfig.FC_REG_COUNTRY == 1 && !this.isGettingCountries && this.countries.length === 0) {
          this.getCountries();
        }
      },
    },
  },
  created() {
    if (this.fairConfig.FC_REG_COUNTRY == 1) this.getCountries();
  },
  mounted() {
    this.init();
  },
  methods: {
    ...mapActions(["login","setRolId"]),
    ...mapMutations(["CHANGE_IS_LOGGED", "CHANGE_EMAIL"]),
    init() {
      switch (this.routeParam) {
        case "login":
          this.modalComponent = Login;
          break;
        case "register":
          this.modalComponent = Register;
          break;
        case "forgotpassword":
          this.modalComponent = ForgotPass;
          break;
        case "resetpassword":
          this.modalComponent = ResetPassword;
          break;

        default:
          this.modalComponent = Login;
          break;
      }
    },
    async getCountries() {
      this.isGettingCountries = true;
      try {
        const result = await api.getCountries();
        this.countries = result.data.countries;
        if (this.countries) {
          this.registerFields[1].push({
            text: "country",
            type: "select",
            options: this.countries.map((el) => {
              return {
                label: el.name,
                code: el.id,
              };
            }),
            validator(val) {
              return this.options.findIndex((el) => el.code === val) !== -1;
            },
          });
        }
      } catch (error) {
        console.log(error);
      } finally {
        this.isGettingCountries = false;
      }
    },
    async handleLogin(params) {
      if (this.onCall) {
        return;
      }
      this.startLoading();
      this.onCall = true;
      try {
        let res = await this.login(params);
        if (res.data.sid) {
          localStorage.setItem("sid", res.data.sid);
          this.setRolId(res.data.rol_id) 
          localStorage.setItem("rol_id", res.data.rol_id);
          localStorage.setItem("usr_id", res.data.usr_id);
          this.CHANGE_IS_LOGGED(true);
          if (res.data.ust_code === 'ADM') this.setIsAdmin(true);
          this.$emit("get-videos");
          localStorage.setItem('ust_id', res.data.ust_id)
          this.$router.push("/");
          api.mixpanel({
            event: "Sign_in",
          });
          this.postEventTracking({ code: "sign_in", data:"" })
          await this.getPermissions();
        }
        this.EventBus.$emit("login");
      } catch (error) {
        console.log(error);
        if (error.response.data.status === "validate") {
          this.CHANGE_EMAIL(params.email);
          this.$router.push("/validate?q=true");
          return;
        }
        this.EventBus.$emit("error", new Error(error.response.data.message));
      } finally {
        this.onCall = false;
        this.stopLoading();
      }
    },
    handleNext(data) {
      this.params = Object.assign(this.params, data);
      if (!this.lastRegisterPage) {
        this.activeField++;
        this.componentResetKey++;
      } else {
        this.handleRegister();
      }
    },
    async handleRegister() {
      this.startLoading();
      if (this.onCall) {
        return;
      }
      this.onCall = true;
      try {
        let params = {
          firstname: this.params.name,
          lastname: this.params.lastName,
          email: this.params.email,
          password: this.params.password,
        };
        if (this.fairConfig.FC_REG_BIRTHDAY == 1) {
          params.birthdate = moment(new Date(this.params.year, 1, 1)).format(
            "YYYY-MM-DD"
          )
        }
        if (this.fairConfig.FC_REG_GENDER == 1) params.gender = this.params.gender;
        if (this.fairConfig.FC_REG_COUNTRY == 1) params.country = this.params.country;
        if (this.fairConfig.FC_REG_CITY == 1) params.city = this.params.city;
        
        let res = await api.register(params);
        if (res.data.result.toLowerCase() === "ok") {
          this.CHANGE_EMAIL(params.email);
          this.$router.push({ name: "Validate", params: { isRegistered: true } });
          api.mixpanel({
            event: "Email_confirmed",
          });
        }
      } catch (error) {
        console.log(error);
        this.EventBus.$emit("error", new Error(error.response.data.message));
      } finally {
        this.stopLoading();
        this.onCall = false;
      }
    },
    handleTerms() {
      this.EventBus.$emit('open-html-modal', {
        customUrl: "/terms-and-conditions.html"
      })
    },
    handlePrivacy() {
      this.EventBus.$emit('open-html-modal', {
        customUrl: "/privacy.html"
      })
    },

  },
};
</script>
<style lang="scss" scoped>
.home {
  display: flex;
  justify-content: center;
  align-items: center;
  background: url("/background.png") center center / cover;
  height: 100vh;
  margin: 0;
}
</style>
